import script from "./VinificationItem.vue?vue&type=script&setup=true&lang=js"
export * from "./VinificationItem.vue?vue&type=script&setup=true&lang=js"

import "./VinificationItem.vue?vue&type=style&index=0&id=72af0132&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72af0132"]])

export default __exports__